import { OrderedMap } from "immutable";
import { v4 as uuidv4 } from "uuid";
import { DEFAULT_TIMERANGE } from "views/Constants";
import Query, { createElasticsearchQueryString, newFiltersForQuery } from "views/logic/queries/Query";
import generateId from "logic/generateId";
export default (streamId, streamCategory, id = generateId(), timeRange, queryString, searchFilters) => {
  const streamIds = streamId ? streamId instanceof Array ? streamId : [streamId] : null;
  const streamCategories = streamCategory ? streamCategory instanceof Array ? streamCategory : [streamCategory] : null;
  const queryFilter = newFiltersForQuery(streamIds, streamCategories);
  const searchFiltersMap = searchFilters ? OrderedMap(searchFilters == null ? void 0 : searchFilters.map((filter) => [filter.id || uuidv4(), filter])) : OrderedMap();
  const builder = Query.builder().id(id).query(queryString != null ? queryString : createElasticsearchQueryString()).timerange(timeRange != null ? timeRange : DEFAULT_TIMERANGE).filters(searchFiltersMap.toList());
  return queryFilter ? builder.filter(queryFilter).build() : builder.build();
};
